import { render, staticRenderFns } from "./@PopupSectionTaskGalleryEditNew.vue?vue&type=template&id=3f939f1a&scoped=true&"
import script from "./@PopupSectionTaskGalleryEditNew.vue?vue&type=script&lang=js&"
export * from "./@PopupSectionTaskGalleryEditNew.vue?vue&type=script&lang=js&"
import style0 from "./@PopupSectionTaskGalleryEditNew.vue?vue&type=style&index=0&id=3f939f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f939f1a",
  null
  
)

export default component.exports